import BaseModel from './base/BaseModel.model';

export default class Faculty extends BaseModel {
   public name?: string;
   public description?: string;
   public researchCenterId?: number;
   
    init() {
       this.researchCenterId = 0;
       this.name = "";
       this.description = "";
    }
}